import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Hash, Loader2, Search, Wrench } from "lucide-react";
import { API } from "../App";
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";

/** Admin → Εργαλεία: διόρθωση ΕΑΚ με διπλό έτος («79/2025» → «79», το έτος εμφανίζεται από το ΓΑΚ). */
export const EakFixCard = () => {
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try { setPreview((await axios.post(`${API}/admin/normalize-eak?dry_run=true`)).data); }
    catch (e) { toast.error(e.response?.data?.detail || "Σφάλμα προεπισκόπησης ΕΑΚ"); }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); }, []);
  const apply = async () => {
    setBusy(true);
    try {
      const r = (await axios.post(`${API}/admin/normalize-eak`)).data;
      toast.success(r.message);
      await load();
    } catch (e) { toast.error(e.response?.data?.detail || "Σφάλμα διόρθωσης ΕΑΚ"); }
    finally { setBusy(false); }
  };
  const n = (preview?.with_year_suffix || 0) + (preview?.junk_values || 0);
  return (
    <Card data-testid="eak-fix-card">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2"><Hash className="w-4 h-4 text-sky-700" />Διόρθωση ΕΑΚ (διπλό έτος)</CardTitle>
        <CardDescription>
          Το πεδίο ΕΑΚ πρέπει να περιέχει ΜΟΝΟ τον αριθμό — το έτος προστίθεται αυτόματα στην εμφάνιση (ΕΑΚ/έτος ΓΑΚ). Τιμές όπως «79/2025»
          (π.χ. από παλαιότερη ενημέρωση SOLON) εμφανίζονταν ως «79/2025/2025». Το εργαλείο τις καθαρίζει· νέες ενημερώσεις SOLON/εισαγωγές αποθηκεύουν πλέον μόνο τον αριθμό.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center gap-3 text-sm">
        <span data-testid="eak-fix-status">
          ΕΑΚ με έτος: <b className={preview?.with_year_suffix ? "text-red-700" : "text-emerald-700"}>{preview?.with_year_suffix ?? "…"}</b>
          {" · "}άκυρες τιμές: <b>{preview?.junk_values ?? "…"}</b>
        </span>
        <Button size="sm" variant="ghost" onClick={load} disabled={busy} data-testid="eak-fix-refresh"><Search className="w-4 h-4" /></Button>
        <Button size="sm" onClick={apply} disabled={busy || !n} data-testid="eak-fix-apply">
          {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Wrench className="w-4 h-4 mr-1" />}Διόρθωση {n ? `(${n})` : ""}
        </Button>
        {preview?.samples?.length > 0 && (
          <div className="w-full text-xs text-slate-500 flex flex-wrap gap-1" data-testid="eak-fix-samples">
            {preview.samples.slice(0, 10).map((s) => <span key={s.gak} className="px-1.5 py-0.5 bg-slate-50 border rounded">ΓΑΚ {s.gak}: {s.old} → {s.new}</span>)}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
